/*=========================================================================================
  File Name: getters.js
  Description: Vuex Store - getters
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import { CONST } from "../assets/utils/constants";

// added so later we can keep breakpoint in sync automatically using this config file
// import tailwindConfig from "../../tailwind.config.js"

const getters = {
  // COMPONENT
  // vx-autosuggest
  // starredPages: state => state.navbarSearchAndPinList.data.filter((page) => page.highlightAction),
  windowBreakPoint: (state) => {
    // This should be same as tailwind. So, it stays in sync with tailwind utility classes
    if (state.windowWidth >= 1200) return "xl";
    else if (state.windowWidth >= 992) return "lg";
    else if (state.windowWidth >= 768) return "md";
    else if (state.windowWidth >= 576) return "sm";
    else return "xs";
  },
  getCurrentRole(state) {
    return state.userInfo ? state.userInfo.role_id : null;
  },
  isAdminRole(state) {
    return state.userInfo ? state.userInfo.role_id === CONST.ADMIN : false;
  },
  isClientRole(state) {
    return state.userInfo ? state.userInfo.role_id === CONST.CLIENT : false;
  },
  projectReviewReport(state) {
    return state.projectReviewReports || false;
  },
};

export default getters;
